export function getFirebaseConfig() {
    var apiKey = process.env.CS_FIREBASE_API_KEY;
    var authDomain = process.env.CS_FIREBASE_AUTH_DOMAIN;
    var projectId = process.env.CS_FIREBASE_PROJECT_ID;
    var storageBucket = process.env.CS_FIREBASE_STORAGE_BUCKET;
    var messagingSenderId = process.env.CS_FIREBASE_MESSAGING_SENDER_ID;
    var appId = process.env.CS_FIREBASE_APP_ID;
    var measurementId = process.env.CS_FIREBASE_MEASUREMENT_ID;
    if (!apiKey || !projectId || !appId || !measurementId) {
        return null;
    }
    return {
        apiKey: apiKey,
        authDomain: authDomain,
        projectId: projectId,
        storageBucket: storageBucket,
        messagingSenderId: messagingSenderId,
        appId: appId,
        measurementId: measurementId
    };
}
